import { CRM } from "@/components/atomic-crm/root/CRM";
import { echoflicksCrmConfig } from "@/echoflicksBranding";
import { localStorageStore } from "ra-core";

// Key the ra-core store version to the deploy id (Vercel commit SHA, injected by
// vite `define`). ra-core wipes every `RaStoreEchoflicksCRM.*` key when the
// stored version differs from this one, so any stale list state (e.g. a
// `contacts.listParams` filter cached while the list was broken) self-heals on
// the next release instead of blanking a list until the user clears storage by
// hand. Mirrors the React Query persist `buster` (also `__APP_BUILD_ID__`), so
// the store and the query cache invalidate together on every deploy.
const store = localStorageStore(__APP_BUILD_ID__, "EchoflicksCRM");

/**
 * Application entry point
 *
 * Customize Atomic CRM by passing props to the CRM component:
 *  - companySectors
 *  - darkTheme
 *  - dealCategories
 *  - dealPipelineStatuses
 *  - dealStages
 *  - lightTheme
 *  - logo
 *  - noteStatuses
 *  - taskTypes
 *  - title
 * ... as well as all the props accepted by shadcn-admin-kit's <Admin> component.
 *
 * @example
 * const App = () => (
 *    <CRM
 *       logo="./img/logo.png"
 *       title="Acme CRM"
 *    />
 * );
 */
const App = () => <CRM {...echoflicksCrmConfig} store={store} />;

export default App;
